import { inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { TENANT_ROUTES_PERMISSIONS } from '@ui-core/constants/routes-permissions.constant'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { UserRolesConditionEnum } from '@ui-core/enums/user-roles.enum'
import { TenantRouteConfigInterface } from '@ui-core/interfaces/route-config.interface'
import { RouteService } from './route.service'
import { UserService } from './user.service'

@Injectable({
    providedIn: 'root'
})
export class TenantService {
    private readonly router = inject(Router)
    private readonly routeService = inject(RouteService)
    private readonly userService = inject(UserService)

    setCurrentRouteAdditionalConfig(tenantRoutes: TenantRouteConfigInterface, currentRoute: string) {
        const routeConfig = tenantRoutes.routes.find((route) => route.path === currentRoute)

        const routeIndex = this.router.config.findIndex((r) => r.path === routeConfig?.path)
        const data = this.router.config[routeIndex]?.data || {}

        const routeData: Record<string, unknown> = {
            ...data,
            permission: routeConfig?.permission || null
        }

        this.router.config[routeIndex] = {
            ...this.router.config[routeIndex],
            data: routeData
        }

        this.routeService.setData(routeData)
    }

    isRouteAllowed(tenantRoutes: TenantRouteConfigInterface, currentRoute: string): boolean {
        const routeConfig = tenantRoutes.routes.find((route) => route.path === currentRoute)
        const RoutesEnumObject = Object.values(RoutesEnum)

        if (RoutesEnumObject.includes(currentRoute as RoutesEnum)) {
            if (routeConfig?.permission.condition === UserRolesConditionEnum.Any) {
                if (!this.userService.hasAnyRole(routeConfig?.permission.roles || [])) {
                    this.router.navigate([RoutesEnum.FORBIDDEN])
                    return false
                }
            }

            if (routeConfig?.permission.condition === UserRolesConditionEnum.All) {
                if (!this.userService.hasRoles(routeConfig?.permission.roles || [])) {
                    this.router.navigate([RoutesEnum.FORBIDDEN])
                    return false
                }
            }
        }

        return true
    }

    async tenantRoutes(tenant: string): Promise<TenantRouteConfigInterface> {
        const loader = TENANT_ROUTES_PERMISSIONS[tenant]

        if (!loader) {
            this.router.navigate([RoutesEnum.ERROR_TENANT])
            return { tenant, routes: [] }
        }

        const tenantRoutes = await loader()

        return tenantRoutes
    }
}
